<template>
  <label class="input-inside-chat-label">
    <span>{{ text }}</span>
    <multiselect
      class="input-inside-chat-tags"
      :class="{ 'error': validate.$invalid && validate.$dirty }"
      :value="value"
      track-by="name"
      label="text"
      :options="options"
      :multiple="true"
      :taggable="true"
      @input="$emit('input', $event)"
      select-label=""
      deselect-label="✗"
      selected-label="✔"
      placeholder=""
    ></multiselect>
  </label>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'ChatMultiSelect',

  components: {
    Multiselect
  },

  props: {
    text: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default () { return [] }
    },
    options: {
      type: Array,
      default () { return [] }
    },
    validate: {
      type: Object,
      default () { return {} }
    }
  }
}
</script>
